import { init, send } from 'emailjs-com';

// Initialize EmailJS with your user ID (public key)
init("K9ipeFzhCT1nTpHpU");

/**
 * Send an email using EmailJS
 * 
 * @param {string} serviceId - The EmailJS service ID
 * @param {string} templateId - The EmailJS template ID
 * @param {object} templateParams - Parameters to populate the email template
 * @param {string} userId - Your EmailJS user ID (public key)
 * @returns {Promise} - Promise resolving with the response
 */
export const sendEmail = (serviceId, templateId, templateParams) => {
  return send(
    serviceId,
    templateId,
    templateParams,
    "K9ipeFzhCT1nTpHpU" // Your public key
  );
};

/**
 * Example usage:
 * 
 * import { sendEmail } from './emailService';
 * 
 * // Inside your component or function
 * const handleSubmit = (e) => {
 *   e.preventDefault();
 *   
 *   const templateParams = {
 *     from_name: 'John Doe',
 *     to_name: 'Recipient',
 *     message: 'Hello, this is a test email!',
 *     reply_to: 'john@example.com',
 *   };
 *   
 *   sendEmail(
 *     'YOUR_SERVICE_ID',  // Replace with your actual service ID
 *     'YOUR_TEMPLATE_ID', // Replace with your actual template ID
 *     templateParams
 *   )
 *     .then((response) => {
 *       console.log('Email sent successfully!', response);
 *     })
 *     .catch((error) => {
 *       console.error('Error sending email:', error);
 *     });
 * };
 */

// The private key (PVhT5_2KEM2paO5rBtWNK) is generally not used directly in the front-end code
// It's used for API calls from your server or for access to certain admin features 